export const userServiceV1 = '/user_svc/api/v1';
export const dataServiceV1 = '/data_svc/api/v1';
export const apiServiceV1 = '/api/service/v1';
export const appServiceV1 = '/api/app/v1';
export const orderServiceV1 = '/order_svc/api/v1';
export const paymentServiceV1 = '/payment_svc/api/v1';
export const notifyServiceV1 = '/notify_svc/api/v1';